import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;

  .ant-collapse-header {
    align-items: center !important;
  }

  & > button:first-of-type {
    align-self: flex-end;
  }

  & > form {
    display: flex;
    flex-direction: column-reverse;
    gap: 16px;
    padding-bottom: 16px;

    @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
      display: grid;
      position: relative;
      grid-template-columns: 0.7fr 0.3fr;

      & > :nth-child(2) {
        margin-bottom: auto;
        position: sticky;
        top: 0;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding: 16px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EmptyMaterialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 40px 20px;

  p {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black7};
    margin: 0;
    padding: 0;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.black7};
  }
`;

export const EmptyMaterialIcon = styled.span`
  > span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    width: 30px;
    height: 30px;
  }
`;

export const StyledUl = styled.ul`
  list-style-type: none;
  padding-left: 16px;
`;

export const StyledLi = styled.li`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

export const StyledP = styled.p`
  padding-left: 16px;
`;
